/**
 * Index
 *
 * フロントで使用する JS をまとめて読み込む
 */

import './scss/main.scss';
import 'slick-carousel';
import * as modules from "./modules";

// コンポーネント
modules.backButton('data-back-button');
modules.diagnosis('js-diagnosis');
modules.expandableToc('#toc_container');
modules.fixedNavi('js-fixed-navi', 'toc_container');
modules.rankingFilters('ranking-pickup', 'js-ranking-filter', 'js-ranking-fixed');
modules.tabSwitch('js-tab-switch');

// 検索機能
modules.searchButton();
modules.selectMap('.js-select-map');
modules.selectSearchFilter();

// ユーティリティ関数
modules.draggable('.js-draggable');
modules.showMore('.js-show-more', 'grid');
modules.toggleCurrentNavItem();
modules.toggleModal('data-modal');
modules.smoothScroll();

// ダイアログのクリックイベント
document.querySelectorAll('dialog').forEach(dialog => {
	dialog.addEventListener('click', event => {
		if (event.target === dialog) {
			dialog.close();
		}
	});
});

// スライダー
const slickElement = document.querySelector("#js-slick");
if (slickElement) {
	jQuery(slickElement).slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		arrows: false,
		dots: true,
		dotsClass: 'p-slider__dots',
		slidesToShow: 1,
	});
}

import ScrollHint from 'scroll-hint';

const scrollHintOptions = {
	scrollHintIconAppendClass: 'scroll-hint-icon-white',
	i18n: {
		scrollable: 'スクロールできます'
	}
};

const selectors = [
	'.p-sticky-table',
	'.p-sticky-table--ranking',
	'.p-rankingWrap',
	'.js-draggable'
];

selectors.forEach(selector => {
	new ScrollHint(selector, scrollHintOptions);
});
